import { Form } from 'antd';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { IState } from 'redux/reducers';
import { PutMeRequest, UpdateMe } from 'services/me.service';

export function useCurrentUser() {
  const authState = useSelector((state: IState) => state.auth);

  return authState.currentUser;
}

export function useSaveMe() {
  const [isSaving, setIsSaving] = useState(false);
  const [form] = Form.useForm();

  const save = async (payload: PutMeRequest) => {
    setIsSaving(true);
    try {
      return await UpdateMe(payload);
    } finally {
      setIsSaving(false);
    }
  };

  return { isSaving, save, form };
}
